import { useState } from 'react'

import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
} from 'app/common/ui-next/plain-modal'

import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'

import styles from './add-identifier-in-frame.module.scss'

export const AddIdentifierInFrame = ({
  modalHeader = 'Добавление идентификатора',
  noFrameMessage = 'Извините, Ваш браузер не поддерживает встроенные фреймы, Вы не сможете пополнить счет! Попробуйте в другом браузере.',
  closeButtonText = 'Закрыть',
  frameUrl,
  children,
  onToggled,
}: {
  modalHeader?: string
  noFrameMessage?: string
  closeButtonText?: string
  frameUrl: string
  children: (toggleModal: () => void) => React.ReactNode
  onToggled?: (prevState: boolean) => void
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModal = () => {
    onToggled?.(isModalOpen)
    setIsModalOpen((state) => !state)
  }

  return (
    <>
      {children(toggleModal)}
      {isModalOpen && (
        <PlainModal className={styles.root} show>
          <PlainModalHeader onCrossClick={toggleModal}>{modalHeader}</PlainModalHeader>
          <PlainModalContent className={styles.frameContainer} maxHeight="min(66vh, 650px)">
            <iframe
              src={frameUrl}
              scrolling="no"
              className={styles.frame}
              title={modalHeader}
              allow="payment; clipboard-write"
              referrerPolicy="no-referrer-when-downgrade"
            >
              {noFrameMessage}
            </iframe>
          </PlainModalContent>
          <PlainModalFooter>
            <ControlsBar right>
              <PlainButton onClick={toggleModal}>{closeButtonText}</PlainButton>
            </ControlsBar>
          </PlainModalFooter>
        </PlainModal>
      )}
    </>
  )
}
